import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { SWRConfig } from 'swr';
import { jsx as _jsx } from "react/jsx-runtime";
export var WEB_TV_SWR_DEDUPING_INTERVAL = 5000;
export var SWRConfigShell = function SWRConfigShell(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return /*#__PURE__*/_jsx(SWRConfig, {
    value: _objectSpread({
      fetcher: undefined,
      dedupingInterval: WEB_TV_SWR_DEDUPING_INTERVAL,
      revalidateOnFocus: false,
      errorRetryCount: 4
    }, value),
    children: children
  });
};